/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function AISimplifyLanguage({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#AISimplifyLanguage_svg__a)"><path fill="currentColor" d="M10.454 10.47c-.421 0-.74-.108-.955-.324-.206-.215-.331-.497-.376-.847h-.067a1.778 1.778 0 0 1-.74.982c-.35.233-.798.35-1.345.35-.708 0-1.273-.184-1.694-.552-.421-.376-.632-.892-.632-1.546 0-.673.247-1.184.74-1.533.502-.359 1.268-.538 2.299-.538h1.331v-.538c0-.941-.497-1.412-1.492-1.412-.449 0-.812.09-1.09.27-.277.17-.51.398-.699.685l-.874-.713c.197-.376.53-.7.995-.968.466-.278 1.067-.417 1.802-.417.879 0 1.569.21 2.071.632.502.421.753 1.031.753 1.829v3.483h.874v1.156h-.9Zm-3.066-.915c.475 0 .865-.108 1.17-.323.305-.215.457-.493.457-.834V7.39H7.711c-1.058 0-1.587.318-1.587.955v.268c0 .314.112.552.336.713.224.153.534.229.928.229Z" /><path stroke="currentColor" strokeDasharray="2 3" strokeLinecap="round" strokeWidth={1.2} d="M1.125 15.444h13.75" /></g><defs><clipPath id="AISimplifyLanguage_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;